// extracted by mini-css-extract-plugin
export default {"CustomerRatings":"CustomerRating-module__CustomerRatings--NM7F","customerRatings":"CustomerRating-module__customerRatings--KxZ3"};